
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiReorderVerticalGoogle as ObiReorderVerticalGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-reorder-vertical-google.js';
 
 
 

 
 export const ObiReorderVerticalGoogle = createComponent({
   react: React,
   tagName: 'obi-reorder-vertical-google',
   elementClass: ObiReorderVerticalGoogleElement,
   events: {
     
   }
  });
 
 